import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AddNewLaundryCustomerService {

  constructor(private http: HttpClient) {}

  addCustomer(customerData: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}/api/new-customer`, customerData);
  }

}
